<template>
  <div>
    <b-row>
      <b-col>
        <b-card
          no-body
        >
          <b-card-header>
            <b-col
              lg="2"
              class="my-1"
            >
              <b-form-group
                class="mb-0"
              >
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                  class="w-50"
                />
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              class="my-1"
            >
              <b-form-group
                label="Filter"
                label-cols-sm="1"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <Can
              i="manage"
              a="sites"
            >
              <b-col
                label-cols-sm="2"
                class="my-1"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-center
                  variant="outline-primary"
                  block
                  @click="$router.push('/sites/addSite')"
                >
                  + Add Site
                </b-button>
              </b-col>
            </Can>
          </b-card-header>

          <b-table
            v-if="sites"
            striped
            hover
            :per-page="perPage"
            :current-page="currentPage"
            :items="sites"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            show-empty
            empty-text="No sites found."
            :busy="isBusy"
            @filtered="onFiltered"
            @row-clicked="onRowClick"
          >
            <!--- is busy template -->
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle mr-1" />
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(device)="data">
              <div v-if="data.item.objects.items.length > 0">
                <b-button
                  size="sm"
                  pill
                  variant="primary"
                  @click="$router.push(`/device/${data.item.objects.items[0].devices.items[0].id}`)"
                >
                  {{ data.item.objects.items[0].devices.items[0].name }}
                </b-button>
              </div>
            </template>

            <template #cell(object)="data">
              <div v-if="data.item.objects.items.length > 0">
                <b-button
                  size="sm"
                  pill
                  variant="success"
                  @click="$router.push(`/object/${data.item.objects.items[0].id}`)"
                >
                  {{ data.item.objects.items[0].name }}
                </b-button>
              </div>
            </template>

            <template #cell(actions)="data">
              <Can
                i="manage"
                a="site"
              >
                <b-button-group>
                  <b-button
                    variant="flat-primary"
                    class="btn-icon"
                    @click="showEditModal(data)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    variant="flat-primary"
                    class="btn-icon"
                    @click="showDeleteModal(data)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </b-button-group>
              </Can>
            </template>

            <!---
            <template #cell(status)="data">
              <b-button-group>
                <b-button
                  v-if="data.item.devices.items[0]"
                  variant="success"
                  class="btn-icon"
                  disabled="true"
                >
                  <feather-icon icon="WifiIcon" />
                </b-button>
                <b-button
                  v-if="!data.item.devices.items[0]"
                  variant="danger"
                  class="btn-icon"
                  disabled="true"
                >
                  <feather-icon icon="WifiOffIcon" />
                </b-button>

              </b-button-group>
            </template>
-->
            <template #cell(level)="data">
              <b-badge :variant="level[1][data.value]">
                {{ level[0][data.value] }}
              </b-badge>
            </template>
          </b-table>

          <b-col
            cols="12"
            class="mb-2 mt-2"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <b-modal

      id="editSiteModal"
      ref="editSiteModal"
      title="Edit Site"
      ok-title="Save"
      cancel-variant="outline-primary"
      ok-variant="primary"
      @ok="updateSite"
    >
      <div
        v-if="'id' in site"
        class="container"
      >
        <b-row>
          <b-col>
            <b-form-group
              label="Name"
              label-for="name"
            >
              <b-form-input
                id="siteName"
                ref="siteName"
                v-model="site.name"
                required
                placeholder="Enter Site Name"
                :state="site.name.length > 0"
              />
            </b-form-group>

            <b-form-group
              label="Address"
              label-for="address"
            >
              <b-form-input
                id="address"
                v-model="site.address"
                required
                placeholder="Enter address"
              />
            </b-form-group>

            <b-form-group
              label="Zip Code"
              label-for="zipCode"
            >
              <b-form-input
                id="zipCode"
                v-model="site.zip_code"
                required
                placeholder="Enter zip code"
              />
            </b-form-group>

            <b-form-group
              label="City"
              label-for="city"
            >
              <b-form-input
                id="city"
                v-model="site.city"
                required
                placeholder="Enter city"
              />
            </b-form-group>

            <b-form-group
              label="Sub Region"
              label-for="subRegion"
            >
              <b-form-input
                id="subRegion"
                v-model="site.subRegion"
                required
                placeholder="Enter sub region"
              />
            </b-form-group>

            <b-form-group
              label="Region"
              label-for="region"
            >
              <b-form-input
                id="region"
                v-model="site.region"
                required
                placeholder="Enter region"
              />
            </b-form-group>

            <b-form-group
              label="Country"
              label-for="country"
            >
              <b-form-input
                id="country"
                v-model="site.country"
                required
                placeholder="Enter country"
              />
            </b-form-group>

            <b-form-group
              label="AWS Long Lat"
              label-for="AWSLongLat"
            >
              <b-form-input
                id="AWSLongLat"
                v-model="site.AWSLongLat"
                required
                placeholder="Enter AWS Long Lat"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Ripple from 'vue-ripple-directive'
import { API } from 'aws-amplify'
import {
  VBModal,
  BCard,
  BTable,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  VBToggle,
  BButtonGroup,
  BCardHeader,
  BSpinner,
  BModal,

} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import * as queries from '../../graphql/queries'
import { Can } from '@casl/vue'

import * as mutations from '../../graphql/mutations'
import * as queries from '../../graphql/queries'

export default {
  components: {
    BCard,
    BCardHeader,
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BButtonGroup,
    BSpinner,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    Can,
    BModal,

  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      isBusy: false,
      nextId: '',
      perPage: 100,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'region',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        { key: 'name', label: 'Site Name', sortable: true },
        { key: 'address', label: 'Address', sortable: true },
        { key: 'city', label: 'City', sortable: true },
        { key: 'region', label: 'Region', sortable: true },
        { key: 'country', label: 'Country', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      sites: [],
      site: {},
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.sites.length
  },
  async created() {
    await this.listSites()
    // this.getFreezerLevel()
  },
  setup() {
    const isAddNewSiteActive = ref(false)
    return {
      // Modal
      isAddNewSiteActive,
    }
  },
  methods: {
    triggerToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      },
      {
        position: 'bottom-right',
      })
    },
    addNewSite() {
      this.isAddNewSiteActive = true
    },
    showDeleteModal(data) {
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete ${data.item.name}`, {
        title: 'Please Confirm',
        size: 'md',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
      })
        .then(async value => {
          if (value === true) {
            await this.deleteSite(data.item.id)
          }
        })
    },
    async deleteSite(siteId) {
      // eslint-disable-next-line no-unused-vars
      const deleteSite = {
        id: siteId,
      }
      // eslint-disable-next-line no-unused-vars
      await API.graphql({
        query: mutations.deleteSite,
        variables: {
          input: deleteSite,
        },
      }).then(response => {
        if (response.error) {
          this.triggerToast(`${response.error}`, 'danger', 'DeleteIcon')
        } else {
          this.triggerToast('Site deleted successfully', 'success', 'CheckCircleIcon')
          this.sites = []
          this.listSites()
        }
      })
    },
    showEditModal(data) {
      this.site = data.item
      this.$refs.editSiteModal.show()
    },
    async updateSite(event) {
      if (this.site.name.length === 0) {
        this.$refs.siteName.focus()
        event.preventDefault() // prevent modal from submitting
      } else {
        const updateSite = {
          id: this.site.id,
          name: this.site.name,
          address: this.site.address,
          zip_code: this.site.zip_code,
          city: this.site.city,
          region: this.site.region,
          subRegion: this.site.subRegion,
          country: this.site.country,
          AWSLongLat: this.site.AWSLongLat,
        }
        await API.graphql({
          query: mutations.updateSite,
          variables: {
            input: updateSite,
          },
        }).then(response => {
          if (response.error) {
            this.triggerToast(`${response.error}`, 'danger', 'DeleteIcon')
          } else {
            this.triggerToast('Site updated successfully', 'success', 'CheckCircleIcon')
            this.sites = []
            this.listSites()
          }
        })
      }
    },
    async listSites(nextToken) {
      this.isBusy = true
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspaceId,
          nextToken,
        },
      }).then(async response => {
        if (this.sites.length === 0) {
          this.sites = response.data.getWorkspace.sites.items
        } else if (this.sites.length > 0) {
          this.sites.push(...response.data.getWorkspace.sites.items)
        }
        if (response.data.getWorkspace.sites.nextToken) {
          this.listSites(response.data.getWorkspace.sites.nextToken)
        }
      })
      this.isBusy = false
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowClick(event) {
      window.location.href = `/site/${event.id}`
    },
  },
}
</script>

<style></style>
